import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keypadBottomButtonsStyles = makeStyles((theme: any) => ({
  keypadBottomButtons: {
    flex: 'auto',
    width: 'calc(100% + 2px)',
    margin: '0 -1px -1px -1px',
  },
  keypadBottomButtonsPriceOverrideMode: {
    marginTop: '9.9vh',
  },
  keypadActionButton: {
    border: `1px solid ${themeColor.secondaryLight}`,
    lineHeight: '1.14',
    letterSpacing: '1.25px',
    fontWeight: 500,
    fontSize: vh(2.08),
    background: theme?.configColors?.primaryColor || theme.primaryMain,
    color: theme?.configColors?.primaryText || theme.white,
    '&:hover': {
      opacity: 0.9,
      color: theme?.configColors?.primaryText || theme.white,
      background: theme?.configColors?.primaryColor || theme.primaryMain,
    },
  },
}));
